export const mailPlaceHolders = [
  'CaseId',
  'CaseLink',
  'CaseStatus',
  'CurrentAssignee',
  'CaseCreatedBy',
  'AssignedBy',
  'CaseType',
  'CaseCreationDate',
  'ClaimNumber',
  'CarRegistrationNumber',
  'Vin',
  'CalculationDate',
  'CalculationBy',
  'CalculationAmount',
  'ServiceInDate',
  'ServiceOutDate',
  'ServiceContractNumber',
  'CaseRequestText',
  'VehicleBrand',
  'VehicleModel',
  'VehicleFabricationDate',
  'VehiclePowerKw',
  'VehicleEngineSizeCc',
  'VehicleEngineCode',
  'OrganizationAddress',
  'UserFirstName',
  'UserLastName',
  'UserPhoneNumber',
  'UserName',
  'ClientFirstName',
  'ClientLastName',
  'ClientCompanyName',
  'ClientContactPerson',
  'OrganizationName',
  'OrganizationCity',
  'OrganizationPhone',
  'OrganizationLogo',
  'VehicleVersion',
  'VehicleEquipmentVersion',
  'CaseClient',
  'NumberOfKilometers',
  'CostCenter',
  'DeliveryAdress',
  'FullDeliveryAddress',
  'AppointmentId',
  'AppointmentLink',
  'RcrEmployeeEmail',
  'RcrEmployeePhone',
  'RcrEmployeeFirstName',
  'RcrEmployeeLastName',
  'AlertTypeName',
  'AlertExpirationDate',
  'OrderId',
  'OrderLink',
  'NotificationClientFirstName',
  'NotificationClientLastName',
  'NotificationClientCompanyName',
  'NotificationClientEmail',
  'NotificationClientPhone',
  'NotificationClientComment',
  'NotificationClientCaseId',
  'NotificationClientCaseLink',
  'CaseComment',
  'SubscriptionName',
  'SubscriptionCardExpirationDate',
  'FleetAppointmentLink',
  'DriverFirstName',
  'DriverLastName',
  'DriverEmail',
  'EmailConfirmationLink',
  'FleetVehicleAlertLink',
  'FleetDriverAlertLink',
  'FleetPricingLink',
  'FleetTrialDaysLeft',
  'FleetUserFirstName',
  'FleetUserLastName',
  'FleetSubscriptionRenewalDate',
  'FleetSubscriptionBilledAmount',
  'FleetPaymentDate',
  'FleetUserEmail',
  'FleetUserPhoneNumber',
  'SubscriptionCarCount',
  'FleetPaymentBilledAmount',
  'FleetImportedBy',
  'FleetImportErrors',
  'EnrollCreatedByName',
  'EnrollPasswordConfirmationTime',
  'AppointmentVehicleBrand',
  'AppointmentVehicleModel',
  'AppointmentVehicleFabricationYear',
  'AppointmentVehiclePlateNumber',
  'AppointmentVehicleVin',
  'AppointmentVehicleKilometers',
  'AppointmentJobType',
  'AppointmentJobDetails',
  'AppointmentDate',
  'AppointmentHour',
  'AppointmentAlternativeDate',
  'AppointmentAlternativeHour',
  'AppointmentClientName',
  'AppointmentClientEmail',
  'AppointmentClientPhone',
  'AppointmentAppName',
  'VehicleAtmManufactureYear',
  'VehicleAtmEnginePower',
  'VehicleAtmEngineCapacity',
  'VehicleAtmFuelType',
  'InterventionType',
  'CostCenterCode',
  'ValidationRequestText',
  'AppointmentServiceName',
  'AppointmentServiceAddress',
  'SupplierVerificationUserFirstName',
  'SupplierVerificationUserLastName',
  'SupplierVerificationUserName'
];
